export default "__VITE_ASSET__7bc1c4aa__"